import { symbolActionTypes } from "../actions/symbolActions";

let _arrSymbol = [];
for (var _i = 0; _i < 1000; _i++) {
    _arrSymbol.push({ code: "R" + _i, count: 0 });
}

const initState = {
    initTime: 0,
    updateTime: 0,
    symbolInfos: [],
    symbolMatch: {},
    symbolPriceChart: {},
    putThroughInfo: { counter: 0, datas: [] },
    symbolTPRLInfos: [],
};

export const symbolReducer = (state = initState, { type, payload }) => {
    switch (type) {
        case symbolActionTypes.UPDATEDATA:
            return {
                ...state,
                symbolInfos: payload.data,
                initTime: payload.isInit ? (new Date()).getTime() : state.initTime,
                updateTime: (new Date()).getTime()
            };
        case symbolActionTypes.UPDATEDATACHART:
            return {
                ...state,
                symbolMatch: payload
            };
        case symbolActionTypes.UpdatePriceChart:
            return {
                ...state,
                symbolPriceChart: payload,
            };
        case symbolActionTypes.UpdatePutThroughInfo:
            return {
                ...state,
                putThroughInfo: payload,
            };
        case symbolActionTypes.UpdateDataTPRL:
            return {
                ...state,
                symbolTPRLInfos: payload.data,
                initTime: payload.isInit ? (new Date()).getTime() : state.initTime,
                updateTime: (new Date()).getTime()
            };
        default:
            return state;
    }
};
